import { fabric } from "fabric";

export default class DeskpadPrintplate {
  constructor(canvas) {
    this.canvas = canvas;
    fabric.Object.prototype.setLeft = function setLeft(left) {
      this.left = left;
    };
    fabric.Object.prototype.setTop = function setTop(top) {
      this.top = top;
    };
  }

  handleOverlaping(options) {
    const canvas = options.target.canvas;
    if (!canvas) return;
    function calculateSquare(canvas) {
      let fitSquare = 0;
      canvas
        .getObjects()
        .filter(obj => obj.order)
        .forEach(obj => {
          fitSquare += obj.getScaledWidth() * obj.getScaledHeight();
        });
      let fitPercentage = (fitSquare * 100) / (canvas.cutW * canvas.cutH);
      fitSquare = fitSquare / (100 * 100 * 10 * 10);

      return {
        percent: fitPercentage,
        m2: fitSquare
      };
    }
    const square = calculateSquare(canvas);
    canvas.fire("printplate:square", square);

    options.target.setCoords();
    const elements = canvas.getObjects();
    for (let index = 0; index < elements.length; index++) {
      const element = elements[index];
      element.set("opacity", 1);
    }

    canvas
      .getObjects()
      .filter(o => o.excludeFromExport === false)
      .forEach(function(obj) {
        canvas
          .getObjects()
          .filter(o => o.excludeFromExport === false)
          .forEach(function(obj2) {
            if (obj === obj2) {
              return;
            }
            if (
              obj2.isContainedWithinObject(obj) ||
              obj2.intersectsWithObject(obj) ||
              obj.isContainedWithinObject(obj2)
            ) {
              obj2.set("opacity", 0.5);
            }
          });
      });
  }

  handleSpaning(options) {
    function findNewPos(distX, distY, target, obj) {
      // See whether to focus on X or Y axis
      const additionalShift = 0.01;
      if (Math.abs(distX) > Math.abs(distY)) {
        if (distX > 0) {
          target.setLeft(obj.left - target.getScaledWidth() - additionalShift);
        } else {
          target.setLeft(obj.left + obj.getScaledWidth() + additionalShift);
        }
      } else {
        if (distY > 0) {
          target.setTop(obj.top - target.getScaledHeight() - additionalShift);
        } else {
          target.setTop(obj.top + obj.getScaledHeight() + additionalShift);
        }
      }
    }

    const activeObj = options.target;
    const snap = 0;
    const canvas = options.target.canvas;
    if (!canvas) return;

    const canvasWidth = canvas.cutW;
    const canvasHeight = canvas.cutH;

    // Sets corner position coordinates based on current angle, width and height
    activeObj.setCoords();
    if (typeof options.e === "undefined") {
      return;
    }
    if (!options.e.altKey) {
      return;
    }
    if (activeObj.left < snap) {
      // Don't allow objects off the canvas
      activeObj.setLeft(0);
    }
    if (activeObj.top < snap) {
      activeObj.setTop(0);
    }

    if (activeObj.getScaledWidth() + activeObj.left > canvasWidth - snap) {
      activeObj.setLeft(canvasWidth - activeObj.getScaledWidth());
    }

    if (activeObj.getScaledHeight() + activeObj.top > canvasHeight - snap) {
      activeObj.setTop(canvasHeight - activeObj.getScaledHeight());
    }

    // Loop through objects
    canvas
      .getObjects()
      .filter(o => o.excludeFromExport === false)
      .forEach(function(obj) {
        if (obj === activeObj) return;

        // If objects intersect
        if (
          activeObj.isContainedWithinObject(obj) ||
          activeObj.intersectsWithObject(obj) ||
          obj.isContainedWithinObject(activeObj)
        ) {
          var distY =
            (obj.top + obj.getScaledHeight()) / 2 -
            (activeObj.top + activeObj.getScaledHeight()) / 2;
          var distX =
            (obj.left + obj.getScaledWidth()) / 2 -
            (activeObj.left + activeObj.getScaledWidth()) / 2;

          // Set new position
          findNewPos(distX, distY, activeObj, obj);
        }
      });

    activeObj.setCoords();

    if (activeObj.left < snap) {
      // Don't allow objects off the canvas
      activeObj.setLeft(0);
    }
    if (activeObj.top < snap) {
      activeObj.setTop(0);
    }

    if (activeObj.getScaledWidth() + activeObj.left > canvasWidth - snap) {
      activeObj.setLeft(canvasWidth - activeObj.getScaledWidth());
    }

    if (activeObj.getScaledHeight() + activeObj.top > canvasHeight - snap) {
      activeObj.setTop(canvasHeight - activeObj.getScaledHeight());
    }
    return;
  }
  handleRotate(e) {
    const obj = e.target;
    if (obj.angle) {
      obj.rotate(0);
    } else {
      obj.rotate(90);
    }
  }

  enable() {
    this.canvas.on("object:moving", this.handleSpaning);
    this.canvas.on({
      "object:moving": this.handleOverlaping,
      "object:scaling": this.handleOverlaping,
      "object:rotating": this.handleOverlaping,
      "object:added": this.handleOverlaping,
      "object:mousedblclick": this.handleRotate
    });
    this.canvas.hasControlCallback.mtr = false;
  }

  disable() {
    this.canvas.off("object:moving", this.handleSpaning);
    this.canvas.off({
      "object:moving": this.handleOverlaping,
      "object:scaling": this.handleOverlaping,
      "object:rotating": this.handleOverlaping,
      "object:added": this.handleOverlaping,
      "object:mousedblclick": this.handleRotate
    });
    this.canvas.hasControlCallback.mtr = true;
  }

  addOrder(order) {
    const { canvas } = this;
    const { preview, size } = order;
    if (!canvas) {
      return;
    }

    fabric.Image.fromURL(preview, function(img) {
      img.scaleToWidth(size.width + 6);
      img.scaleY = (size.height + 6) / img.height;
      img.generateId();
      // img.type = "order";

      img.borderColor = "#e3007b";
      img.cornerColor = "#e3007b";
      img.borderScaleFactor = 1;
      img.padding = -0.05;

      img.lockScalingX = true;
      img.lockScalingY = true;
      img.lockUniScaling = true;
      img.lockRotation = true;
      // img.order = order;
      img.size = order.size;

      const group = new fabric.Group([img], { left: 0, top: 0 });
      group.generateId();
      group.objectCaching = false;
      group.order = order;

      group.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
        bl: false,
        br: false,
        tl: false,
        tr: false,
        mtr: false
      });
      canvas.add(group);
      canvas.requestRenderAll();
    });
  }
}
